import React from "react";

import { Table, TableContainer } from "@material-ui/core";

import CustomTableFooter from "../../common/CustomTableFooter/CustomTableFooter";
import PlolygonServicesCardHeader from "./PlolygonServicesCardHeader";
import PlolygonServicesCardBody from "./PlolygonServicesCardBody";

interface PlolygonServicesCardSectionInterface {
  classes: any;
  rowsData: any;
  currentCountry: any;
  userInfo: any;
  appStateObj: any;
  appliedServiceTypes: Array<string>;
  fetchNextRecord: any;
  handleFilterPopupOpen: any;
  handleFilterPopupClose: any;
  appFilterPopUpObj: any;
  headerRowCheckboxOnChange: any;
  handlePosZoneSearch: any;
  handlePosZoneSearchTextChange: any;
  handleResetPopUpOnClick: any;
  handleApplyPopUpOnClick: any;
  handlePolygonDetailsClick: (polygonId: string, serviceType?: string) => void;
}

const PlolygonServicesCardSection = (props: PlolygonServicesCardSectionInterface) => {
  const {
    classes,
    rowsData,
    currentCountry,
    userInfo,
    appStateObj,
    appliedServiceTypes,
    fetchNextRecord,
    handleFilterPopupOpen,
    handleFilterPopupClose,
    appFilterPopUpObj,
    headerRowCheckboxOnChange,
    handlePosZoneSearch,
    handlePosZoneSearchTextChange,
    handleResetPopUpOnClick,
    handleApplyPopUpOnClick,
    handlePolygonDetailsClick
  } = props;

  // Polygon ID column + one column per visible service type
  const totalColumnCount = (Array.isArray(appliedServiceTypes) ? appliedServiceTypes.length : 0) + 1;

  return (
    <div className={classes.cardRoot}>
      <TableContainer className={classes.tableContainerStyle}>
        <Table padding="none" size="small" stickyHeader={true}>
          <PlolygonServicesCardHeader
            classes={classes}
            handleFilterPopupOpen={handleFilterPopupOpen}
            handleFilterPopupClose={handleFilterPopupClose}
            appFilterPopUpObj={appFilterPopUpObj}
            headerRowCheckboxOnChange={headerRowCheckboxOnChange}
            handlePosZoneSearch={handlePosZoneSearch}
            handlePosZoneSearchTextChange={handlePosZoneSearchTextChange}
            currentCountry={currentCountry}
            handleResetPopUpOnClick={handleResetPopUpOnClick}
            handleApplyPopUpOnClick={handleApplyPopUpOnClick}
            appStateObj={appStateObj}
            appliedServiceTypes={appliedServiceTypes}
          />
          <PlolygonServicesCardBody
            classes={classes}
            rowsData={rowsData}
            currentCountry={currentCountry}
            userInfo={userInfo}
            appFilterPopUpObj={appFilterPopUpObj}
            appStateObj={appStateObj}
            appliedServiceTypes={appliedServiceTypes}
            totalColumnCount={totalColumnCount}
            handlePolygonDetailsClick={handlePolygonDetailsClick}
          />
          {rowsData && Array.isArray(rowsData) && rowsData.length > 0 && (
            <CustomTableFooter
              rowsData={rowsData}
              classes={classes}
              colSpan={totalColumnCount}
              pageSize={appStateObj.size ?? 40}
              rowCount={appStateObj.maxRecordPresent ?? 0}
              page={Number(appStateObj.page ?? 1) - 1}
              fetchNextRecord={fetchNextRecord}
            />
          )}
        </Table>
      </TableContainer>
    </div>
  );
};

export default React.memo(PlolygonServicesCardSection);
